import React, { useEffect, useState, forwardRef } from 'react';
import { CheckType } from '../../../functions/checkType';
import { AutoGrow } from '../functions/AutoGrow';

const TextArea = forwardRef(({
  fieldName,
  wrapperClass = '',
  label,
  hideLabel = false,
  allowNull = true,
  value = '',
  errors = [],
  disabled = false,
  helpText = '',
  placeholder = '',
  inputClass = '',
  onChange = () => {},
  pk = null
}, ref) => {
    if(CheckType(value) === "Object"){
      value = JSON.stringify(value, null, "\t")
    }
    const [inputValue, setInputValue] = useState(value);
    const localOnChange = (e) => {
        AutoGrow(e.target)
        setInputValue(e.target.value)
        // onChange(e)
    }
    const onBlur = (e) => {
        onChange({'name':fieldName, 'value': e.target.value, 'label': e.target.value})
    }
    useEffect(() => {
        AutoGrow(document.getElementById(pk ? pk + '_' + fieldName : fieldName))
        setInputValue(value)
    }, [value])


  return <textarea
        key={pk ? pk + '_' + fieldName : fieldName}
        id={pk ? pk + '_' + fieldName : fieldName}
        ref={ref}
        name={fieldName}
        className={`form-control ${inputClass} ${errors.length > 0 ? 'is-invalid has-error' : ''}`}
        placeholder={placeholder}
        value={inputValue}
        onChange={localOnChange}
        onBlur={onBlur}
        disabled={disabled}
      />
});

export default TextArea;
